var iconHeight = $(".product-icons").outerHeight();
if ($(".luxreaders-product-description").length > 0) {
    var productDescriptionHeight = $(".luxreaders-product-description").outerHeight();
    heightAlignment();
    $(window).resize(function(){
        productDescriptionHeight = $(".luxreaders-product-description").outerHeight();
        iconHeight = $(".product-icons").outerHeight();
        heightAlignment();
    })
    
}

function heightAlignment() {
    if (productDescriptionHeight === iconHeight) {
        var pTop = $(".luxreaders-product-description p:first").offset().top;
        $(".icons-wrapper").offset({ top: pTop });
    } else {
        $(".icons-wrapper").css({ top: '0' });
    }
}